module.exports = __webpack_public_path__ + "media/images/common/ico-insta-387b2cb676c45e0984173a62fedd85c8.svg";